import React from "react";
import { Figure } from "./Figure";
import CTAButton from "./cta-button/ctaButton";
import shareButton from "./share-button/shareButton";
import starsRating from "./stars-rating/starsRating";
import usersReviews from "./users-reviews/usersReviews";
import video from "./s3-video/video";
import htmCode from "./html-code/htmCode";
import reviewSection from "./review-section/reviewSection";
import mediaSection from "./media-section/mediaSection";
import ctaSection from "./cta-section/ctaSection";
import ChooseButton from "./choose-button/chooseButton";
import ProductVideo from "./product-video/productVideo";
import productVideoSection from "./product-video-section/productVideoSection";
import TestimonialVideo from "./testimonial-video/testimonialVideo";
import testimonialVideoSection from "./testimonial-video-section/testimonialVideoSection";
import FAQ from "./faq/faq";
import faqSection from "./faq-section/faqSection";
import Price from "./price/price";
import priceSection from "./price-section/priceSection";

const serializers = {
  types: {
    /* eslint-disable-next-line react/display-name */
    authorReference: ({ node }) => <span>{node.author.name}</span>,
    mainImage: Figure,
    ctaButton: CTAButton,
    shareButton: shareButton,
    starsRating: starsRating,
    usersReviews: usersReviews,
    video: video,
    htmCode: htmCode,
    reviewSection: reviewSection,
    mediaSection: mediaSection,
    ctaSection: ctaSection,
    chooseButton: ChooseButton,
    productVideoSection: productVideoSection,
    productVideo: ProductVideo,
    testimonialVideoSection: testimonialVideoSection,
    testimonialVideo: TestimonialVideo,
    faqSection: faqSection,
    faq: FAQ,
    priceSection: priceSection,
    price: Price,
  },
};

export default serializers;
